import React from "react";
import { A } from "hookrouter";
import styles from "../Login.module.css";

const Tabs = ({ active }) => {
  return (
    <div className={styles.tabs}>
      <A href={"/login"} className={active === "login" ? styles.active : ""}>
        Login
      </A>
      <A
        href={"/register"}
        className={active === "register" ? styles.active : ""}
      >
        Signup
      </A>
    </div>
  );
};

export default Tabs;
